import { Illustration, Text } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

export namespace RateManagementPillButtonTypes {
  export interface Props {
    isMobile: boolean;
  }
}
export const FeedbackExpired: React.FC<RateManagementPillButtonTypes.Props> = ({ isMobile }) => {
  return (
    <>
      <Illustration name="WarningIllustration" testId={'warning-illustration'} />
      <Text
        textAlign={'center'}
        paddingTop={Spacing['stack.xxxs']}
        fontSize={Utils.Responsive.All({
          phone: Typography['fontsize.xs'],
          tablet: Typography['fontsize.xs'],
          desktop: Typography['fontsize.md'],
        })}
        variant="bold"
        color="neutral.black">
        Link inválido ou expirado.
      </Text>
      <Text
        textAlign={'center'}
        fontSize={Utils.Responsive.All({
          phone: Typography['fontsize.xs'],
          tablet: Typography['fontsize.xs'],
          desktop: Typography['fontsize.md'],
        })}
        maxWidth={isMobile ? 320 : '40%'}
        lineHeight="medium"
        color="neutral.black">
        A duração do link excedeu o tempo limite, será necessário refazer o processo, entre em
        contato com o time responsável.
      </Text>
    </>
  );
};
